<template>
  <div class="home-box">
    <v-progress-linear
      indeterminate
      color="orange"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-card class="pa-5 mt-5">
        <v-card-title dark>
        <h3 class="ma-2 orange--text">Contribution Towards to MJF | Month: {{ month }}</h3>
        <v-spacer></v-spacer>
        <go-back-btn></go-back-btn>
      </v-card-title>
      <v-divider color="orange"></v-divider>
      <div>
        <v-simple-table>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left">
                  Name
                </th>
                <th class="text-left">
                  Date
                </th>
                <th class="text-left">
                  Document1
                </th>
                <th class="text-left">
                  Document2
                </th>        
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in details" :key="item.uuid">
               <td v-if="item.member_id">{{ item.member_id.display_name }}</td>
                <td>{{ item.date }}</td>
                <td v-if="item.documents.length > 0"><a :href="item.documents[0].path" target="_blank">Click hear</a></td>
                <td v-else>NA</td>
                <td v-if="item.documents.length > 1"><a :href="item.documents[1].path" target="_blank">Click hear</a></td>               
                <td v-else>NA</td>         
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    </v-card>    
    <Snackbars
      :text="successMsg"
      :snackbar="snackbar"
      :color="'success'"
      @classSnackbar="closeSnackbar"
    />
  </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");
import Alert from "@/components/shared/Alert";
import Snackbars from "@/components/shared/Snackbars";
import { ActivityService } from "../../../services/activity-service.js";
import { checkError } from "@/config/errors.js";
import GoBackBtn from "@/components/shared/GoBackBtn";

export default {
  name: "MjfContribution",

  components: { Alert, Snackbars, GoBackBtn },

  data: () => ({
    cpRole: false,
    loading: false,
    errors: null,
    snackbar: false,
    month:null,
    successMsg: "Successfully added",
    role: localStorage.getItem("role"),
    form: {
      pending_comment: "",
    },
    details: [],
    confirm: false,
  }),

  mounted() {
    this.month = this.$route.params.month;
    if( this.$route.params.aId){
      this.getDetails(this.$route.params.aId);
    }
  },

  computed: {
    ...mapGetters({
      member: "profile",
    }),
  },

  methods: {
    getDetails(uuid){
      ActivityService.getActivityInfo("mjf-contribution-details", uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
           this.details = response.data?.data?.details || []
          }
        })
        .catch((error) => {
          this.loading = false;
          this.details = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });

    },

    deleteDetail(uuid){
      ActivityService.deleteActivity("mjf-contribution-details", uuid)
        .then((response) => {
          this.loading = false;
          if (response.data.data) {
          this.getDetails(this.uuid);
          }
        })
        .catch((error) => {
          this.loading = false;
          this.details = [];
          let data = error.response.data;
          let errorOutput = checkError.errorFormatting(data);
          this.errors = errorOutput;
        });
    },

    onDismissed() {
      this.errors = null;
    },
    closeSnackbar() {
      this.snackbar = false;
    },    
  },
};
</script>
